import axios from "axios";

export async function submitPinkForm(data) {
  const response = await axios.post(
    `${process.env.REACT_APP_API_URL}wallet/defund-card-user-details`,
    data,
  );
  return response.data;
}
